import { VnmfPlatformBase } from '@vnxjs/service'

import { components } from './components'
import { Template } from './template'

const PACKAGE_NAME = '@vnxjs/plugin-platform-swan'
const PROJECT_JSON = 'project.swan.json'

export default class Swan extends VnmfPlatformBase {
  platform = 'swan'
  globalObject = 'swan'
  runtimePath = `${PACKAGE_NAME}/dist/runtime`
  vnmfComponentsPath = `${PACKAGE_NAME}/dist/components-react`
  fileType = {
    templ: '.swan',
    style: '.css',
    config: '.json',
    script: '.js',
    xs: '.sjs'
  }

  template: Template

  /**
   * 1. setupTransaction - init
   * 2. setup
   * 3. setupTransaction - close
   * 4. buildTransaction - init
   * 5. build
   * 6. buildTransaction - close
   */
  constructor (ctx, config) {
    super(ctx, config)

    this.setupTransaction.addWrapper({
      close () {
        this.modifyComponents()
        ctx.generateFrameworkInfo()
        this.generateProjectConfig(PROJECT_JSON, PROJECT_JSON)
      }
    })

    this.template = new Template({
      flattenViewLevel: config.flattenViewLevel
    })
  }

  /**
   * Add component or modify properties
   */
  modifyComponents () {
    this.template.mergeComponents(this.ctx, components)
    delete this.template.internalComponents.Input.cursor
    delete this.template.internalComponents.Input['selection-start']
    delete this.template.internalComponents.Input['selection-end']
  }
}
